// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3a4A8","actionsCol":"EnrolledClinics_actionsCol__16ndq"};